import { isAvatarSrc, thumbnailMediumBlue } from '@utils/thumbnails'
import useDrawerContext from '@contexts/drawerContext'
import { useAuthContext } from '@contexts/authContext'
import { Avatar, ButtonBase } from '@mui/material'
import { size } from '@styles/theme'
import styled from '@emotion/styled'

const StyledAvatar = styled(Avatar)`
  height: ${size(3.75)};
  width: ${size(3.75)};
  border: 0.75px solid rgba(255,255,255,0.25);
`

const AppBarAvatar = ({ children, ...rest }) => {
  const { state: { user } } = useAuthContext()
  const { openLeftDrawer } = useDrawerContext()
  // const userPicture = user?.imageUrls?.user_profile_small || user?.imageUrls?.user_nearby_main_medium
  const isAvatar = isAvatarSrc('medium', user?.nearbyMedia?.thumbnails?.[0], user?.defaultAvatar)
  const userThumbnail = thumbnailMediumBlue(user?.nearbyMedia?.thumbnails?.[0], user?.defaultAvatar)

  return (
    <ButtonBase
      onClick={openLeftDrawer}
      style={{ borderRadius: '100%' }}>
      <StyledAvatar
        slotProps={{ img: { style: { filter: isAvatar && 'grayscale(100%) contrast(120%)' } }}}
        alt='Your User Picture Or Avatar'
        src={userThumbnail}
        {...rest}>
        {children}
      </StyledAvatar>
    </ButtonBase>
  )
}

export default AppBarAvatar
